import $ from 'jquery';

export default function int_custom() {
	$(".go_bottom").click(function (e) {
		e.preventDefault();
		let par = $(this).closest("section");
		//$('body').scrollTo(par.next());
		par.next().get(0).scrollIntoView({behavior: 'smooth'});
	})
}

